import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ListingIcon from './ListingIcon';
import AddListing from './AddEditListing';
import { useUser } from '../../../../UserContext';
import { getVendorListings, getReviewsByVendor, unpublishListing } from "../../../API_Handler";
import ProfileNavBar from "../ProfileNavBar/ProfileNavBar";
import { useToast } from '../../../../Common/ToastContext';
import SearchBar from "../SearchBar/SearchBar";

const Listings = () => {
  const showToast = useToast();
  const { userListings, setUserListings, userReviews, setUserReviews } = useUser();
  const [listings, setListings] = useState([])
  const [showAddListing, setShowAddListing] = useState(false);
  const [showEditListing, setShowEditListing] = useState(false);
  const [editProductId, seteditProductId] = useState(null);
  const handleAddNewListing = () => { setShowAddListing(true); };
  const [screenLoading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');


  const handleUnpublishClick = async (listing) => {
    const confirmation = window.confirm('Are you sure you want to unpublish this listing?');
    if (!confirmation) return;
    const unpublishedListing = await unpublishListing(listing.id, showToast);
    if (!unpublishedListing) return;
    const updatedListings = listings.map((item) =>
      item.id === listing.id ? unpublishedListing : item
    );
    setListings(updatedListings);
  };

  const handleSearch = (e) => {
    if (e.target.value === '' || e.target.value === null) {
      setListings(userListings);
      return;
    } else {
      setSearchQuery(e.target.value.toLowerCase());
      setListings(filteredListings());
    }
  };

  const filteredListings = () => {
    return Object.values(listings).filter((listing) =>
      listing.name?.toLowerCase().includes(searchQuery) ||
      listing.description?.toLowerCase().includes(searchQuery)
    );
  };

  const setListingsWithReviews = (userListings) => {
    if (!userListings || !userReviews) return;
    const updatedListings = userListings.map((listing) => {
      const matchingReviews = userReviews.filter((review) => review.product.id === listing.id);
      const averageRating = matchingReviews.length > 0
        ? matchingReviews.reduce((total, review) => total + review.rating, 0) / matchingReviews.length
        : null;

      return {
        ...listing,
        rating: averageRating,
      };
    });
    setListings(updatedListings);
  };

  useEffect(() => {
    if (userListings) {
      setListings(userListings);
      setListingsWithReviews(userListings);
      return;
    }
    const fetchListings = async () => {
      setLoading(true);
      const products = await getVendorListings(showToast);
      const reviews = await getReviewsByVendor(showToast);

      // Setting them in user context
      setUserListings(products);
      setUserReviews(reviews);

      //Setting them in component state
      setListings(products);
      setListingsWithReviews(products);
      setLoading(false);
    };
    fetchListings();
  }, []);

  useEffect(() => {
    if (userListings) {
      setListings(userListings);
      setListingsWithReviews(userListings);
      return;
    }
  }, [userListings]);

  const [svgFill, setSvgFill] = useState("#ffa400");

  return (
    <div className="">
      {showAddListing && (
        <div className="w-full mt-[20px] flex flex-col">
          <div className="flex flex-col lg:flex-row justify-between">
            <h4 className="text-[18px] 1.5xl:text-[22px] text-[#505050] font-allroundgothic font-[600] m-0">Add New Listing</h4>
            <div className="relative">
              <button className="mt-[20px] lg:mt-[14px] h-[12px] flex flex-row items-center justify-center font-proximanova text-charmOrange text-[18px] hover:text-charmHover border-b-[1px] border-charmOrange hover:border-charmHover pb-[14px] mb-0"
                onClick={() => setShowAddListing(false)}
                onMouseEnter={() => setSvgFill("#99216c")}
                onMouseLeave={() => setSvgFill("#ffa400")}
              >
                <svg className="mr-1" width="12" height="12" viewBox="0 0 12 17" fill={svgFill} xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.883618 8.59285C0.883618 8.36756 0.987368 8.14232 1.20966 7.9645L10.1018 0.85064C10.5316 0.506818 11.243 0.506818 11.6728 0.85064C12.1026 1.19446 12.1026 1.76358 11.6728 2.10742L3.56609 8.59277L11.6728 15.0781C12.1026 15.422 12.1026 15.9911 11.6728 16.3349C11.243 16.6787 10.5316 16.6787 10.1018 16.3349L1.20966 9.22105C0.987373 9.04322 0.883618 8.81792 0.883618 8.59269V8.59285Z" fill={svgFill} />
                </svg>
                Return to Listings
              </button>
            </div>
          </div>
          <AddListing setShowEditListing={setShowEditListing} setShowAddListing={setShowAddListing} />
        </div>
      )}

      {!showAddListing && showEditListing && (
        <div className="w-full mt-[20px] flex flex-col">
          <div className="flex flex-col lg:flex-row justify-between">
            <h4 className="text-[18px] 1.5xl:text-[22px] text-[#505050] font-allroundgothic font-[600] m-0">Edit Listing</h4>
            <div className="relative">
              <button className="mt-[20px] lg:mt-[14px] h-[12px] flex flex-row items-center justify-center font-proximanova text-charmOrange text-[18px] hover:text-charmHover border-b-[1px] border-charmOrange hover:border-charmHover pb-[14px] mb-0"
                onClick={() => setShowEditListing(false)}
                onMouseEnter={() => setSvgFill("#99216c")}
                onMouseLeave={() => setSvgFill("#ffa400")}
              >
                <svg className="mr-1" width="12" height="12" viewBox="0 0 12 17" fill={svgFill} xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.883618 8.59285C0.883618 8.36756 0.987368 8.14232 1.20966 7.9645L10.1018 0.85064C10.5316 0.506818 11.243 0.506818 11.6728 0.85064C12.1026 1.19446 12.1026 1.76358 11.6728 2.10742L3.56609 8.59277L11.6728 15.0781C12.1026 15.422 12.1026 15.9911 11.6728 16.3349C11.243 16.6787 10.5316 16.6787 10.1018 16.3349L1.20966 9.22105C0.987373 9.04322 0.883618 8.81792 0.883618 8.59269V8.59285Z" fill={svgFill} />
                </svg>
                Return to Listings
              </button>
            </div>
          </div>
          <AddListing
            editMode={true}
            editProductId={editProductId}
            setShowEditListing={setShowEditListing}
            setShowAddListing={setShowAddListing}
          />
        </div>
      )}

      {!showAddListing && !showEditListing && (
        <div className="mt-[20px] flex flex-col">
          <div className="flex flex-col lg:flex-row lg:justify-between lg:items-center">
            <SearchBar handleSearch={handleSearch} text="Search your listings" />
            <div className="w-full h-[40px] flex justify-end mt-[20px] lg:mt-0">
              <button
                className="w-fit text-white px-8 py-auto text-[18px] bg-charmOrange hover:text-integrationRequestTextHover hover:bg-charmHover font-proximanova rounded-full whitespace-nowrap"
                disabled={screenLoading}
                onClick={handleAddNewListing}
              >
                + Add New Listing
              </button>
            </div>
          </div>

          {screenLoading ? (
            <div className="flex items-center justify-center h-screen">
              <div className="spinner-border text-black" role="status" />
            </div>
          ) : !listings?.length ? (
            <div className="h-fit flex flex-col items-center justify-center">
              <p className="py-[180px] text-left text-[18px] text-[#505050] text-center font-proximanova">
                You do not currently have any listings. Please create a new listing to get started.
              </p>
            </div>
          ) : (
            <div className="grid grid-cols-[repeat(auto-fit,minmax(25rem,30rem))] gap-[24px] py-[24px]">
              {listings.map((listing, index) => (
                <div key={index} className="">
                  <ListingIcon
                    listing={listing}
                    seteditProductId={seteditProductId}
                    setShowEditListing={setShowEditListing}
                    handleUnpublishClick={handleUnpublishClick}
                  />
                </div>
              ))}
            </div>

          )}
        </div>
      )}
    </div>
  );

}

export default Listings;